import { render, staticRenderFns } from "./LandingButton.vue?vue&type=template&id=100ba0cf&scoped=true"
import script from "./LandingButton.vue?vue&type=script&lang=js"
export * from "./LandingButton.vue?vue&type=script&lang=js"
import style0 from "./LandingButton.vue?vue&type=style&index=0&id=100ba0cf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100ba0cf",
  null
  
)

export default component.exports